<template>
  <section> 
    <b-row>
      <b-col>
        <b-card
          style="max-width: 100%">
          <template v-slot:header >
            <div class="header-card text-left">
              Lista de Centros de Trabajo    
              <b-button size="sm" @click="nuevoModal()" variant="outline-primary" style="float:right"> Nuevo Centro de Trabajo</b-button>
            </div>          
          </template>
            <b-row>
              <b-col :md="12" style="margin-top:10px">
                  <sw-tableget
                    :tableItems="tableGBItems"
                    :tableSearch="tableGBSearch"
                    :tableOptions="tableGBoptions"
                    name="tableGet"
                    route="get_listcontactos"
                    dataRoute="usuarios"
                    :filterShow="false"
                    @filtrar="getFiltrar"
                    >
                    <template v-slot:modal>
                      <sw-modalcontactos 
                        v-if="openModal.modal.modal==='Editar'"
                        @save="saveForm"                     
                        >
                      </sw-modalcontactos>                  
                      <sw-modalinactive
                        v-if="openModal.modal.modal==='Inactivar'"
                        @save="saveForm"
                        >
                      </sw-modalinactive>  
                    </template>
                  </sw-tableget>                  
              </b-col>              
            </b-row>            
        </b-card>
      </b-col>
    </b-row> 
     <b-modal 
          v-if="openModal.modal.modal==='Nuevo'"
          v-model="openModal.modal.value"
          :title="openModal.modal.title" 
          :header-bg-variant="'primary'"
          header-text-variant="light"
          :hide-footer="true"  
          :no-close-on-backdrop="true" 
          size="lg"  
          >        
            <sw-modalcontactos 
              @save="saveForm"                     
              >
            </sw-modalcontactos>      
        </b-modal>                   
  </section>
</template>

<script>
import indexMix  from './indexMix.js'
import storeMix  from './storeMix.js'
import tableMix  from './tableMix.js'
import saveMix  from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwInputs from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwModalinactive from '@/components/modals/inactive.vue'
import SwModalcontactos from '@/components/modals/contactos.vue'


export default { 
  name: "datos_pacientes",
  mixins: [indexMix,storeMix,tableMix,saveMix,saveMixins,],
  components: {
  SwInputs,
  SwSaveform,
  SwTableget,
  SwModalinactive,
  SwModalcontactos
     
  }
}
</script>
<style>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link
{
  background: #fcfcfc;
  font-weight: 500;
}
</style>

